import React from "react";
import Carousel from "../component/section/carousel";
import CounterComponent from "../component/section/CounterComponent";
import WhyBATSection from "../component/section/whyBAT";
import { useNavigate } from "react-router-dom";

export default function BatHome() {
  const navigate = useNavigate();
  return (
    <div className="bat-main-home">
      <h2 className="footer-title color-red-bat-home fw-500 mt-20 mb-20">
        Brahmin Association of Texas
      </h2>
      <div className="bat-home-bg bg-flower-img"></div>
      <div className="bat-home-section1">
        <div className="bat-home-section1-width">
          <p className="text-center">
            <strong>Brahmin Association of Texas</strong> is a volunteer run
            organization dedicated to support the community and to bring
            awareness on Hindu-Brahmin way of life (Sanatana Dharma), which
            helps to lead a principled life and spreads peace and harmony in the
            community.
          </p>
        </div>
      </div>
      <div className="bat-home-section2 bg-flower-img">
        <div className="section-header">
          <h2 data-description="title" className="color-red-bat-home mb-20">
            BAT Sponsors
          </h2>
          <p className="mb-30">
            Our sincere gratitude to our Esteemed Sponsors
          </p>
          <Carousel />
        </div>
      </div>
      <WhyBATSection isMainBat={true} />
      <div className="bat-home-section4 pb-30 bg-flower-img">
        <div className="section-header">
          <h2
            data-description="title"
            className="color-red-bat-home responsive-title text-center">
            How to Volunteer for BAT?
          </h2>
        </div>
        <h5 className="mb-20  text-center">
          BAT is a 100% volunteer run organization. BAT needs your support for
          organizing several social and community based events
        </h5>
        <div className="d-flex justify-content-center">
          <ul className="pl-30">
            <li>Register on our website as a Member or Volunteer</li>
            <li>Fill up your profile completely</li>
            <li>Members will get exclusive opportunities for certain events</li>
            <li>
              General Volunteers will have opportunity to participate in limited
              events
            </li>
            <li>Keep checking the website for new events</li>
          </ul>
        </div>
      </div>
      <div className="bat-home-section5 pb-30 bg-flower-img">
        <div className="d-flex justify-content-center">
          <div className="serve-the-community">
            <p className="text-center">Serve the Community</p>
          </div>
        </div>

        <div className="section-header">
          <h2
            data-description="title"
            className="color-red-bat-home mt-20 responsive-title text-center">
            Become a BAT member
          </h2>
        </div>
        <p className="mb-20 text-center">
          Become a BAT Member today and show your support to follow and practice
          Sanatana Dharma - Brahmin principles and serve the community
        </p>
        <div className="d-flex justify-content-center mb-30">
          <button
            className="button login-btn create-btn text-white text-center pl-30 pr-30"
            onClick={() => navigate("/join-bat")}>
            Get Started
          </button>
        </div>
      </div>
    </div>
  );
}
